import { execute_generator } from './index'

export const api_url = process.env.VUE_APP_API_TBN_URL
export const tbn_api_url = process.env.VUE_APP_API_TBN_URL

export const get_tbn_actuals = (tenant, filter, booking_search, base, fromDate, toDate) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/actuals/web?tenant=' + tenant + '&filter=' + filter + '&booking_search=' + encodeURIComponent(booking_search || '') + '&base=' + base + '&fromDate=' + fromDate + '&toDate=' + toDate}
).next()

export const get_tbn_vsm_upcoming = (tenant, base, fromDate, toDate) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/vsm/upcoming?tenant=' + tenant + '&base=' + (base || '') + '&fromDate=' + fromDate + '&toDate=' + toDate}
).next()

export const get_tbn_actuals_fabbus = (filter, fromDate, toDate) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/actuals/web/fabbus?filter=' + filter + '&fromDate=' + fromDate + '&toDate=' + toDate}
).next()

export const reprocess_actuals = (tenant, filter, base, fromDate, toDate) => execute_generator(
    'PATCH', { service: api_url, resource: 'tbn/actuals/reprocess?tenant=' + tenant + '&filter=' + filter  + '&base=' + base + '&fromDate=' + fromDate + '&toDate=' + toDate}
).next()

export const reprocess_tbn_actual = (tenant, tbnBookingHash) => execute_generator(
    'PATCH', { service: api_url, resource: 'tbn/actuals/reprocess_one?tenant=' + tenant + '&tbn_booking_hash=' + encodeURIComponent(tbnBookingHash || '')}
).next()

// admin-only manual outbound send; bypasses the tenant's outbound enabled/filter config
export const send_tbn_actual_outbound = (tenant, tbnBookingHash) => execute_generator(
    'PATCH', { service: api_url, resource: 'tbn/actuals/send_outbound_one?tenant=' + tenant + '&tbn_booking_hash=' + encodeURIComponent(tbnBookingHash || '')}
).next()

export const recheck_tbn_overlaps = (tenant, fromDate, toDate) => execute_generator(
    'PATCH', { service: api_url, resource: 'tbn/actuals/overlap_recheck?tenant=' + tenant + '&fromDate=' + fromDate + '&toDate=' + toDate}
).next()

export const get_tbn_actuals_error_summary = (tenant, fromDate, toDate, filter, base) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/actuals/error_summary?tenant=' + tenant + '&start_date=' + fromDate + '&end_date=' + toDate + '&filter=' + (filter || 'finish') + '&base=' + (base || '')}
).next()

export const get_tbn_actuals_planned_vs_actual_summary = (tenant, fromDate, toDate, filter, base) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/actuals/planned_vs_actual?tenant=' + tenant + '&start_date=' + fromDate + '&end_date=' + toDate + '&filter=' + (filter || 'finish') + '&base=' + (base || '')}
).next()

export const get_tbn_actuals_on_time_report = (tenant, fromDate, toDate, filter, base, toYardMinutes, departYardMinutes, toPickupMinutes, type) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/reports/actuals/on_time?tenant=' + tenant + '&start_date=' + fromDate + '&end_date=' + toDate + '&filter=' + (filter || 'finish') + '&base=' + (base || '')
        + '&to_yard_minutes=' + toYardMinutes + '&depart_yard_minutes=' + departYardMinutes + '&to_pickup_minutes=' + toPickupMinutes + '&type=' + encodeURIComponent(type || '')}
).next()

// TBN half of the "At a Glance" widget -- same response contract as
// apis.js's get_tenant_glance, so the widget renders either one.
export const get_tbn_tenant_glance = (tenant, days = 7) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/glance?tenant=' + tenant + '&days=' + days}
).next()

export const get_tbn_actuals_processing_rules = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/actuals/processing_rules?tenant=' + tenant}
).next()

export const save_tbn_actuals_feedback = (tenant, body) => execute_generator(
    'PATCH', { service: api_url, resource: 'tbn/actuals/feedback?tenant=' + tenant }, body
).next()

export const clear_tbn_actuals_feedback_for_date_range = (tenant, fromDate, toDate) => execute_generator(
    'DELETE', { service: api_url, resource: 'tbn/actuals/feedback?tenant=' + tenant + '&fromDate=' + fromDate + '&toDate=' + toDate }
).next()

export const get_tbn_actuals_hos_timeline = (tenant, bookingId, driverName, vehicleAssignmentId, dispatchId, dayOfTrip, tbnBookingHash) => {
    let resource = 'tbn/actuals/hos_timeline?tenant=' + tenant + '&booking_id=' + encodeURIComponent(bookingId || '')
    if (driverName)
        resource += '&driver_name=' + encodeURIComponent(driverName)
    if (vehicleAssignmentId != null && vehicleAssignmentId !== '')
        resource += '&vehicle_assignment_id=' + encodeURIComponent(vehicleAssignmentId)
    if (dispatchId != null && dispatchId !== '')
        resource += '&dispatch_id=' + encodeURIComponent(dispatchId)
    if (dayOfTrip != null && dayOfTrip !== '')
        resource += '&day_of_trip=' + encodeURIComponent(dayOfTrip)
    if (tbnBookingHash != null && tbnBookingHash !== '')
        resource += '&tbn_booking_hash=' + encodeURIComponent(tbnBookingHash)
    return execute_generator('GET', { service: api_url, resource }).next()
}

export const get_hos_by_client_report = (tenant, from, to, reprocess) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/reports/actuals/hoursByClient?tenant=' + tenant + '&fromDate=' + from + '&toDate=' + to + '&reprocess=' + reprocess}
).next()

export const get_tyler_route_options = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/tyler_routes/options?tenant=' + tenant}
).next()

export const process_tyler_routes = (tenant, location, inQA, mode) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/tyler_routes/process?tenant=' + tenant + "&location=" + encodeURIComponent(location) + "&inQA=" + inQA + (mode ? "&mode=" + mode : "")}
).next()



export const get_hos_by_booking_report = (tenant, from, to, reprocess) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/reports/actuals/hoursByBooking?tenant=' + tenant + '&fromDate=' + from + '&toDate=' + to + '&reprocess=' + reprocess}
).next()

export const get_tbn_booking_history = (tenant, processed_time) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/booking/history?tenant=' + tenant + '&processed_time=' + processed_time}
).next()

export const get_tbn_booking_history_range = (tenant, startDate, endDate) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/bookings/history?tenant=' + tenant + '&startDate=' + startDate + '&endDate=' + endDate}
).next()

export const get_tbn_overlap_updates_history = (tenant, startDate, endDate) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/actuals/overlap_updates/history?tenant=' + tenant + '&startDate=' + startDate + '&endDate=' + endDate}
).next()

export const tbn_get_simulated_actuals = (tenant, show_details) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/actuals/simulated?tenant=' + tenant + '&show_details=' + show_details}
).next()

export const tbn_get_vehicle_types = (tenant) => execute_generator(
'GET', { service: api_url, resource: 'tbn/vehicles/types?tenant=' + tenant}
).next()

export const tbn_get_smart_route_assignment_vehicle_types = (tenant) => execute_generator(
'GET', { service: api_url, resource: '/tbn/smart_route_assignments/vehicle/types?tenant=' + tenant}
).next()

export const get_compare_drivers_history = (tenant, from, to) => execute_generator(
'GET', { service: api_url, resource: 'tbn/comparedrivers/history?tenant=' + tenant + '&fromDate=' + from + '&toDate=' + to}
).next()

export const tbn_get_compare_drivers_results = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/comparedrivers?tenant=' + tenant}
).next()

export const get_driver_scorecard = (tenant, driver_id, start_month, end_month) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/driver-scorecard?tenant=' + tenant + '&driver_id=' + driver_id + '&start_month=' + start_month + '&end_month=' + end_month + '&include_comparison=true'}
).next()

export const check_driver_scorecard_precalc = (tenant, driver_id, start_month, end_month) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/driver-scorecard/check-precalc?tenant=' + tenant + '&driver_id=' + driver_id + '&start_month=' + start_month + '&end_month=' + end_month }
).next()

export const get_fleet_scorecard = (tenant, start_month, end_month) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/fleet-scorecard?tenant=' + tenant + '&start_month=' + start_month + '&end_month=' + end_month}
).next()

export const get_all_driver_scorecards = (tenant, start_month, end_month) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/driver-scorecard/all?tenant=' + tenant + '&start_month=' + start_month + '&end_month=' + end_month}
).next()

export const get_driver_scorecard_trends = (tenant, start_month, end_month, driver_id) => {
    let resource = 'tbn/driver-scorecard/trends?tenant=' + tenant + '&start_month=' + start_month + '&end_month=' + end_month
    if (driver_id) resource += '&driver_id=' + encodeURIComponent(driver_id)
    return execute_generator('GET', { service: api_url, resource }).next()
}

export const get_driver_comparison = (tenant, driver_ids, start_month, end_month) => {
    let resource = 'tbn/driver-comparison?tenant=' + tenant + '&start_month=' + start_month + '&end_month=' + end_month
    if (driver_ids && driver_ids.length > 0) {
        resource += '&driver_ids=' + driver_ids.join(',')
    }
    return execute_generator('GET', { service: api_url, resource: resource}).next()
}

export const tbn_get_compare_driver_profile_results = (tenant, includeStatusDiffs = false) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/comparedriverprofiles?tenant=' + tenant + '&include_status_diffs=' + includeStatusDiffs}
).next()

export const tbn_manage_drivers_list = (tenant) => execute_generator(
'GET', { service: api_url, resource: 'tbn/drivers/manage/list?tenant=' + tenant}
).next()

export const tbn_get_driver = (tenant, id) => execute_generator(
'GET', { service: api_url, resource: 'tbn/drivers/' + id + '?tenant=' + tenant}
).next()

export const tbn_update_driver = (tenant, body) => execute_generator(
'PUT', { service: api_url, resource: 'tbn/drivers?tenant=' + tenant}, body
).next()

export const tbn_save_driver_sync_mappings = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'tbn/driversync?tenant=' + tenant}, body
).next()

export const tbn_add_driver_to_tbn = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'tbn/driversync/addDriverToTBN?tenant=' + tenant}, body
).next()

export const tbn_update_tbn_driver = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'tbn/driversync/updateTBNDriver?tenant=' + tenant}, body
).next()

export const tbn_update_all_tbn_drivers = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'tbn/driversync/updateAllTBNDrivers?tenant=' + tenant}, body
).next()

export const get_tbn_vehicle_info = (tenant, selected_base, selected_tag, mode) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/vehicles?tenant=' + tenant + "&selected_base=" + selected_base + "&selected_tag=" + selected_tag + "&mode=" + mode}
).next()

export const get_tbn_trip_sheet = (tenant, date) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/tripsheet?tenant=' + tenant + "&date=" + date}
).next()

export const tbn_get_smart_route_assignments = (tenant, vehicleTypes, fromDate, toDate, autoselect) => execute_generator(
'GET', { service: api_url, resource: 'tbn/smart_route_assignments?tenant=' + tenant + '&vehicleTypes=' + vehicleTypes + '&fromDate=' + fromDate + '&toDate=' + toDate + '&autoselect=' + autoselect}
).next()

export const tbn_update_smart_route_assignment = (tenant, body) => execute_generator(
'PATCH', { service: api_url, resource: 'tbn/smart_route_assignments?tenant=' + tenant}, body
).next()

export const tbn_send_smart_route_assignment_to_tbn = (tenant, body) => execute_generator(
'PATCH', { service: api_url, resource: 'tbn/smart_route_assignments/send_to_tbn?tenant=' + tenant}, body
).next()

export const get_dispatch_board = (tenant, date) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/dispatch_board?tenant=' + tenant + "&date=" + date}
).next()

export const get_booking_bids_for_drivers_board = (tenant, fromDate, toDate, isManager) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/dispatch/bookings/drivers?tenant=' + tenant + '&fromDate=' + fromDate + '&toDate=' + toDate+ '&is_manager=' + isManager}
).next()

export const get_booking_bids_for_drivers_board_base= (tenant, fromDate, toDate, base, driverId, isManager) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/dispatch/bookings/drivers/base?tenant=' + tenant + '&fromDate=' + fromDate + '&toDate=' + toDate + '&base=' + base+ '&driver_id=' + driverId + '&is_manager=' + isManager}
).next()

export const add_update_driver_bid = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'tbn/dispatch/bookings/drivers/bid?tenant=' + tenant}, body
).next()

export const remove_bid_record = (tenant, dispatch_driver) => execute_generator(
    'DELETE', { service: api_url, resource: 'tbn/dispatch/bookings/driver/bid?tenant=' + tenant+ '&dispatch_driver=' + dispatch_driver}
).next()

export const add_update_driver_unavailable = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'tbn/dispatch/bookings/drivers/unavailable?tenant=' + tenant}, body
).next()

export const get_drivers_unavailable_ranges= (tenant, driverId, fromDate, toDate) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/dispatch/bookings/drivers/unavailable/ranges?tenant=' + tenant + '&driver_id=' + driverId + '&fromDate=' + fromDate + '&toDate=' + toDate}
).next()

export const get_driver_unavailability = (tenant, fromDate, toDate) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/dispatch/bookings/drivers/unavailability?tenant=' + tenant + '&fromDate=' + fromDate + '&toDate=' + toDate}
).next()


export const get_booking_bases= (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/dispatch/bookings/bases?tenant=' + tenant}
).next()

export const tbn_update_vehicle_status = (tenant, body) => execute_generator(
    'PATCH', { service: api_url, resource: 'tbn/vehicles?tenant=' + tenant}, body
).next()

export const get_tbn_vehicle_map = (tenant, vehicle_id, samsara_vehicle_id, booking_id) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/vehicle/map?tenant=' + tenant + "&vehicleId=" + vehicle_id + "&samsaraVehicleId=" + samsara_vehicle_id + "&bookingId=" + booking_id}
).next()

export const get_tbn_vehicle_trip_history = (tenant, value, fromDate) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/vehicle/trip/history?tenant=' + tenant + "&vehicle=" + value + "&fromDate=" + fromDate}
).next()

export const get_vehicle_track_fleet_tbn = (tenant, mode, value) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/vehicle/track/fleet?tenant=' + tenant + "&mode=" + mode + "&value=" + value}
).next()

export const get_vehicle_track_fleet_fabbus_route_summary = () => execute_generator(
    'GET', { service: api_url, resource: 'tbn/vehicle/track/fleet/fabbus/route-summary'}
).next()

export const get_tbn_actuals_mileage_report = (tenant, date, reprocess) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/reports/actuals/mileage?tenant=' + tenant + '&date=' + date + '&reprocess=' + reprocess}
).next()

export const get_tbn_actuals_billing_report = (tenant, date) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/reports/actuals/billing?tenant=' + tenant + '&date=' + date}
).next()

export const get_tbn_actuals_start_events_report = (tenant, date) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/reports/actuals/startevents?tenant=' + tenant + '&date=' + date}
).next()

export const get_tbn_actuals_driver_payroll_report = (tenant, date, reprocess, useBookingActuals, config) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/reports/actuals/driverpayroll?tenant=' + tenant + '&date=' + date + '&reprocess=' + reprocess + '&useBookingActuals=' + useBookingActuals + (config && config.poll ? '&poll=true' : '')}, undefined, config
).next()

export const tbn_push_actuals_driver_multiday_to_payroll = (tenant, tag, driver, from_date, to_date) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/reports/actuals/driver/multiday/push?tenant=' + tenant + '&tag=' + tag + '&driver=' + driver + '&fromDate=' + from_date + '&toDate=' + to_date}
).next()

export const get_tbn_intrastate_booking_report = (tenant, from_date, to_date) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/reports/actuals/intrastate_bookings?tenant=' + tenant + '&fromDate=' + from_date + '&toDate=' + to_date}
).next()

export const get_tbn_smart_routing_report = (tenant, from_date, to_date, vehicleType, matchType, miles, min_minutes, max_minutes) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/reports/smart_routing_report?tenant=' + tenant + '&fromDate=' + from_date + '&toDate=' + to_date + '&vehicleType=' + vehicleType + '&matchType=' + matchType + '&miles=' + miles + '&minMinutes=' + min_minutes + '&maxMinutes=' + max_minutes}
).next()

export const get_tbn_vehicle_map_future_data = (
    tenant,
    from_date,
    to_date,
    vehicle = '',
    driver = '',
    booking_type = ''
) => execute_generator(
    'GET',
    {
        service: api_url,
        resource:
            'tbn/vehicle_map_future_data?tenant=' + tenant +
            '&fromDate=' + from_date +
            '&toDate=' + to_date +
            (vehicle ? '&vehicle=' + encodeURIComponent(vehicle) : '') +
            (driver ? '&driver=' + encodeURIComponent(driver) : '') +
            (booking_type ? '&booking_type=' + encodeURIComponent(booking_type) : '')
    }
).next()

export const tbn_get_drivers_list = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/drivers/list?tenant=' + tenant}
).next()

export const get_driver_bid_seniority_list = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/drivers/bid-seniority/list?tenant=' + tenant}
).next()

export const tbn_get_drivers_scorecard_list = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/drivers/scorecard-list?tenant=' + tenant}
).next()

export const tbn_clear_scorecard_driver_list_cache = (tenant) => execute_generator(
    'POST', { service: api_url, resource: 'tbn/drivers/scorecard-list-cache-clear?tenant=' + tenant }
).next()

export const get_tbn_vehicle_map_future_charter_data = (tenant, booking_search) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/vehicle_map_future_charter_data?tenant=' + tenant + '&booking_search=' + encodeURIComponent(booking_search || '')}
).next()

export const get_tbn_booking_categories = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/booking_categories?tenant=' + tenant }
).next()


export const get_tbn_actuals_driver_multiday_report = (tenant, tag, driver, from_date, to_date, reprocess, config) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/reports/actuals/driver/multiday?tenant=' + tenant + '&tag=' + tag + '&driver=' + driver + '&fromDate=' + from_date + '&toDate=' + to_date + '&reprocess=' + reprocess + (config && config.poll ? '&poll=true' : '')}, undefined, config
).next()

export const get_tbn_actuals_payroll_summary_report = (tenant, driver, from_date, to_date, reprocess, config) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/reports/actuals/payroll/summary?tenant=' + tenant + '&driver=' + driver  + '&fromDate=' + from_date + '&toDate=' + to_date + '&reprocess=' + reprocess + (config && config.poll ? '&poll=true' : '')}, undefined, config
).next()

export const get_tbn_vehicle_utilization = (tenant, date) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/vehicle/utilization?tenant=' + tenant + '&date=' + date}
).next()

export const get_tbn_driver_utilization = (tenant, date) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/driver/utilization?tenant=' + tenant + '&date=' + date}
).next()

export const get_tbn_vehicle_calendar = (tenant, hours_offset, date) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/vehicle/calendar?tenant=' + tenant + '&hours_offset=' + hours_offset + '&date=' + date}
).next()

export const get_tbn_drivers_dispatch_weekly = (tenant, date) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/driver/dispatch/weekly?tenant=' + tenant + '&date=' + date}
).next()

export const get_tbn_booking_monthly_calendar = (tenant, fromDate, toDate, hours_offset) => {
    let resource = 'tbn/booking/monthly-calendar?tenant=' + tenant + '&fromDate=' + fromDate + '&toDate=' + toDate
    if (hours_offset != null && hours_offset !== '') {
        resource += '&hours_offset=' + hours_offset
    }
    return execute_generator('GET', { service: api_url, resource: resource }).next()
}

export const get_tbn_hale_daily_dispatch = (tenant, fromDate, toDate, garage) => {
    let resource = 'tbn/hale/daily-dispatch?tenant=' + tenant + '&fromDate=' + fromDate + '&toDate=' + toDate
    if (garage) {
        resource += '&garage=' + encodeURIComponent(garage)
    }
    return execute_generator('GET', { service: api_url, resource: resource }).next()
}

const toQueryString = (params = {}) => Object.keys(params)
    .filter((key) => params[key] !== undefined && params[key] !== null && params[key] !== '')
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&')

export const tbn_get_booking_customer_list = (tenant, params = {}) => {
    const query = toQueryString({
        tenant,
        fromDate: params.fromDate,
        toDate: params.toDate,
        status: params.status,
        orgId: Array.isArray(params.orgId) ? params.orgId.join(',') : params.orgId,
        booking_search: params.booking_search,
    })
    return execute_generator('GET', { service: api_url, resource: `tbn/booking/customers?${query}` }).next()
}

export const tbn_get_booking_customer_detail = (tenant, tbn_booking_hash) => {
    const query = toQueryString({ tenant })
    return execute_generator('GET', { service: api_url, resource: `tbn/booking/customers/${encodeURIComponent(tbn_booking_hash)}?${query}` }).next()
}

export const tbn_get_booking_customer_map = (tenant, params = {}) => {
    const query = toQueryString({
        tenant,
        fromDate: params.fromDate,
        toDate: params.toDate,
        status: params.status,
        orgId: Array.isArray(params.orgId) ? params.orgId.join(',') : params.orgId,
        booking_search: params.booking_search,
    })
    return execute_generator('GET', { service: api_url, resource: `tbn/booking/customers/map?${query}` }).next()
}

export const tbn_get_booking_customer_actuals = (tenant, filter, bookingSearch, fromDate, toDate) => {
    const query = toQueryString({
        tenant,
        filter: filter || 'overlap',
        booking_search: bookingSearch || '',
        fromDate,
        toDate,
    })
    return execute_generator('GET', { service: api_url, resource: `tbn/booking/customers/actuals?${query}` }).next()
}

export const get_tbn_drivers_util_weekly = (tenant, date) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/driver/util/weekly?tenant=' + tenant + '&date=' + date}
).next()

export const get_tbn_vehicle_type_calendar = (tenant, type_mode, hours_offset, fromDate, toDate) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/vehicle/type/calendar?tenant=' + tenant + '&hours_offset=' + hours_offset + '&type_mode=' + type_mode + '&fromDate=' + fromDate + '&toDate=' + toDate}
).next()

export const get_tbn_driver_type_calendar = (tenant, type_mode, hours_offset, fromDate, toDate) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/driver/type/calendar?tenant=' + tenant + '&hours_offset=' + hours_offset + '&type_mode=' + type_mode + '&fromDate=' + fromDate + '&toDate=' + toDate}
).next()

export const get_tbn_actuals_perf_report = (tenant, date) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/reports/actuals/performance?tenant=' + tenant + '&date=' + date}
).next()

export const get_tbn_multiday_otp_report = (tenant, base, fromDate, toDate, dayThreshold, startThreshold, finishThreshold, totalThreshold, consecutiveDaysMode) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/reports/actuals/multiday/otp?tenant=' + tenant + '&base=' + base + '&fromDate=' + fromDate + '&toDate=' + toDate + '&dayThreshold=' + dayThreshold + '&startThreshold=' + startThreshold + '&finishThreshold=' + finishThreshold + '&totalThreshold=' + totalThreshold + '&consecutiveDaysMode=' + consecutiveDaysMode }
).next()

export const get_groupsender_user_list = (tenant, user_type, driverStartTime, driverEndTime) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/groupsender/users?tenant=' + tenant + '&userType=' + user_type + '&driverStartTime=' + driverStartTime + '&driverEndTime=' + driverEndTime}
).next()

export const send_message_to_group = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'tbn/groupsender/send?tenant=' + tenant}, body
).next()

// Fleet Assistant chat endpoints for TBN tenants
export const tbn_send_chat_message = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'tbn/bookings/chat?tenant=' + tenant}, body
).next()

export const tbn_get_chat_session = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/bookings/chat/session?tenant=' + tenant}
).next()

export const tbn_submit_chat_feedback = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'tbn/bookings/chat/feedback?tenant=' + tenant}, body
).next()

export const tbn_clear_chat_session = (tenant) => execute_generator(
    'DELETE', { service: api_url, resource: 'tbn/bookings/chat/session?tenant=' + tenant}
).next()

export const tbn_get_chat_instructions = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/bookings/chat/instructions?tenant=' + tenant}
).next()

export const tbn_list_help_articles = (tenant, params = {}) => {
    const route_name = params.route_name ? '&route_name=' + encodeURIComponent(params.route_name) : ''
    const query = params.query ? '&query=' + encodeURIComponent(params.query) : ''
    const enabled_features = Array.isArray(params.enabled_features) && params.enabled_features.length > 0
        ? '&enabled_features=' + encodeURIComponent(params.enabled_features.join(','))
        : ''
    const limit = params.limit ? '&limit=' + encodeURIComponent(params.limit) : ''
    return execute_generator(
        'GET', { service: api_url, resource: 'tbn/bookings/help/articles?tenant=' + tenant + route_name + query + enabled_features + limit}
    ).next()
}

export const tbn_get_help_article = (tenant, docId, params = {}) => {
    const offset = params.offset ? '&offset=' + encodeURIComponent(params.offset) : ''
    const limit = params.limit ? '&limit=' + encodeURIComponent(params.limit) : ''
    return execute_generator(
        'GET', { service: api_url, resource: 'tbn/bookings/help/articles/' + encodeURIComponent(docId) + '?tenant=' + tenant + offset + limit}
    ).next()
}

export const tbn_submit_help_feedback = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'tbn/bookings/help/feedback?tenant=' + tenant }, body
).next()

export const tbn_record_help_article_view = (tenant, docId) => execute_generator(
    'POST', { service: api_url, resource: 'tbn/bookings/help/articles/' + encodeURIComponent(docId) + '/view?tenant=' + tenant }, {}
).next()

export const tbn_get_help_feedback = (tenant, docId) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/bookings/help/feedback/summary?tenant=' + tenant + '&doc_id=' + encodeURIComponent(docId) }
).next()

export const tbn_list_help_company_documents = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/bookings/help/company-documents?tenant=' + tenant }
).next()

export const tbn_get_help_company_document = (tenant, docId) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/bookings/help/company-documents/' + encodeURIComponent(docId) + '?tenant=' + tenant }
).next()

export const tbn_admin_clear_cache = (tenant, cache_type) => execute_generator(
    'POST', { service: api_url, resource: 'tbn/admin/cache/clear?tenant=' + tenant + '&cache_type=' + cache_type }
).next()

export const get_tbn_api_usage = (tenant, start_date, end_date, tenant_ids) => {
    let qs = '?start_date=' + start_date + '&end_date=' + end_date
    if (tenant) qs += '&tenant=' + tenant
    else if (tenant_ids && tenant_ids.length) qs += '&tenant_ids=' + tenant_ids.join(',')
    return execute_generator(
        'GET', { service: api_url, resource: 'tbn/admin/tbn-api-usage' + qs }
    ).next()
}

export const tbn_download_help_company_document = (tenant, docId) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/bookings/help/company-documents/' + encodeURIComponent(docId) + '/download?tenant=' + tenant }
).next()

// Assistant Insights (admin-only) — TBN parity
export const tbn_get_admin_chat_live_session = (tenant, userId) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/bookings/admin/chat/live-session?tenant=' + tenant + '&user_id=' + encodeURIComponent(userId)}
).next()

export const tbn_get_ai_usage = (tenant, period) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/bookings/ai-usage?tenant=' + tenant + (period ? '&period=' + period : '')}
).next()

export const tbn_get_ai_usage_history = (tenant, months = 12) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/bookings/ai-usage/history?tenant=' + tenant + '&months=' + months}
).next()

export const tbn_get_ai_usage_users = (tenant, period) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/bookings/ai-usage/users?tenant=' + tenant + (period ? '&period=' + period : '')}
).next()

export const tbn_get_ai_usage_fleet = (tenants, period) => execute_generator(
    'POST', { service: api_url, resource: 'tbn/bookings/ai-usage/fleet'}, { tenants, period: period || null }
).next()

export const tbn_get_admin_chat_session = (tenant, sessionId) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/bookings/chat/session/admin?tenant=' + tenant + '&session_id=' + encodeURIComponent(sessionId)}
).next()

export const tbn_list_admin_chat_archived_sessions = (tenant, params = {}) => {
    const qs = Object.entries(params || {}).filter(([, v]) => v !== undefined && v !== null && v !== '').map(([k, v]) => k + '=' + encodeURIComponent(v)).join('&')
    return execute_generator('GET', { service: api_url, resource: 'tbn/bookings/admin/chat/archived-sessions?tenant=' + tenant + (qs ? '&' + qs : '') }).next()
}

export const tbn_get_admin_chat_archived_session = (tenant, sessionId) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/bookings/admin/chat/archived-session?tenant=' + tenant + '&session_id=' + encodeURIComponent(sessionId)}
).next()

export const tbn_get_admin_chat_tools_summary = (tenant, period) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/bookings/admin/chat/tools-summary?tenant=' + tenant + (period ? '&period=' + period : '')}
).next()

// TBN parity for cross-tenant archived/live sessions (support-tenant user view).
export const tbn_list_admin_chat_archived_sessions_cross_tenant = (tenants, userId, limit = 50) => execute_generator(
    'POST', { service: api_url, resource: 'tbn/bookings/admin/chat/archived-sessions-cross-tenant'}, { tenants, user_id: userId, limit }
).next()

export const tbn_get_admin_chat_live_sessions_cross_tenant = (tenants, userId) => execute_generator(
    'POST', { service: api_url, resource: 'tbn/bookings/admin/chat/live-sessions-cross-tenant'}, { tenants, user_id: userId }
).next()


// notification center (FI-1432)
// tenant query param required by @tenant_user_required decorator.

export const tbn_get_user_notifications = (tenant, limit = 20, cursor) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/notifications?tenant=' + tenant + '&limit=' + limit + (cursor ? '&cursor=' + encodeURIComponent(JSON.stringify(cursor)) : '') }
).next()

export const tbn_get_notifications_unread_count = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/notifications/unread-count?tenant=' + tenant }
).next()

export const tbn_mark_notifications_read = (tenant, notification_ids) => execute_generator(
    'POST', { service: api_url, resource: 'tbn/notifications/read?tenant=' + tenant }, { tenant, notification_ids }
).next()

export const tbn_mark_all_notifications_read = (tenant) => execute_generator(
    'POST', { service: api_url, resource: 'tbn/notifications/read?tenant=' + tenant }, { tenant, all: true }
).next()

export const tbn_record_notification_action = (tenant, notification_id) => execute_generator(
    'POST', { service: api_url, resource: 'tbn/notifications/action?tenant=' + tenant }, { tenant, notification_id }
).next()

export const tbn_get_user_announcement = (tenant, announcement_id) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/notifications/announcements/' + encodeURIComponent(announcement_id) + '?tenant=' + tenant }
).next()

export const tbn_register_email_when_ready = (body) => execute_generator(
    'POST', { service: api_url, resource: 'tbn/notifications/email-when-ready?tenant=' + (body && body.tenant) }, body
).next()

export const tbn_register_notification_device = (body) => execute_generator(
    'POST', { service: api_url, resource: 'tbn/notifications/device?tenant=' + (body && body.tenant) }, body
).next()

export const tbn_unregister_notification_device = (tenant, device_id) => execute_generator(
    'DELETE', { service: api_url, resource: 'tbn/notifications/device/' + encodeURIComponent(device_id) + '?tenant=' + tenant }
).next()

export const tbn_admin_create_announcement = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'tbn/admin/announcements?tenant=' + tenant }, body
).next()

export const tbn_admin_list_announcements = (tenant, limit = 20, cursor) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/admin/announcements?tenant=' + tenant + '&limit=' + limit + (cursor ? '&cursor=' + encodeURIComponent(JSON.stringify(cursor)) : '') }
).next()

export const tbn_admin_get_announcement_stats = (tenant, announcement_id) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/admin/announcements/' + encodeURIComponent(announcement_id) + '/stats?tenant=' + tenant }
).next()

export const tbn_admin_delete_announcement = (tenant, announcement_id) => execute_generator(
    'DELETE', { service: api_url, resource: 'tbn/admin/announcements/' + encodeURIComponent(announcement_id) + '?tenant=' + tenant }
).next()

// retract a published announcement — drops per-user notifications and
// flips the canonical row back to status='draft' so the admin can edit
// and republish. draft rows use tbn_admin_delete_announcement instead.
export const tbn_admin_retract_announcement = (tenant, announcement_id) => execute_generator(
    'POST', { service: api_url, resource: 'tbn/admin/announcements/' + encodeURIComponent(announcement_id) + '/retract?tenant=' + tenant }
).next()

export const tbn_admin_get_notifications_system_stats = (tenant, days = 7) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/admin/notifications/system-stats?tenant=' + tenant + '&days=' + days }
).next()
